module.exports = __webpack_public_path__ + "static/media/IC_design_led.4e22990c.svg";